// extracted by mini-css-extract-plugin
export var previewContainer = "_sc-0";